import { ThemeEvents, CartAddEvent } from '@theme/events';
const { cartReload, currencyUpdate } = ThemeEvents;

if (!window.__hdtMinicartQuickAddBound) {
  window.__hdtMinicartQuickAddBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hdt-minicart-recommendations__add-btn');
    if (!btn || btn.classList.contains('is-loading')) return;

    var root = btn.closest('product-recommendations');
    if (!root) return;

    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var spinner = btn.querySelector('.hdt-loading__spinner');
    btn.classList.add('is-loading');
    btn.disabled = true;
    if (spinner) spinner.hidden = false;

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(async function (data) {
        if (data.status) {
          console.error(data.description || data.message);
          document.dispatchEvent(new CustomEvent(ThemeEvents.cartError, {
            bubbles: true,
            detail: { sourceId: 'quick-add', data: { message: data.description || data.message } }
          }));
          return;
        }

        var slide = btn.closest('.hdt-slider__slide');
        if (slide) {
          slide.style.transition = 'opacity .25s ease, transform .25s ease';
          slide.style.opacity = '0';
          slide.style.transform = 'scale(.9)';
          setTimeout(function () { slide.remove(); }, 250);
        }

        var cart;
        try {
          cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
        } catch (err) {
          console.error(err);
          return;
        }

        document.dispatchEvent(new CartAddEvent(
          data,
          'quick-add',
          cart,
          'open-drawer',
          'quick-add',
          { itemCount: cart.item_count, variantId: variantId }
        ));

        document.dispatchEvent(new CustomEvent(cartReload, { bubbles: true }));
        document.dispatchEvent(new CustomEvent(currencyUpdate, { bubbles: true }));

        var drawerEl = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
        drawerEl?.closest('hdt-drawer')?.open();
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (spinner) spinner.hidden = true;
      });
  });
}